import '../Style/Fade.less'
import util from '@/Common/API/util'
export default Vue => {
    console.warn('Common/meta/index plugin');
    Vue.prototype._transitionName = 'fade'
    Vue.prototype._jumpTo = function (route, params, query) {
        this.$router.push({
            name: route,
            params,
            query
        })
    }
    Vue.prototype._jump = function (route, query) {
        this.$router.push({
            name: route,
            query
        })
    }
    Vue.prototype._jumpPre = function () {
        this.$router.back()
    }
    Vue.prototype._linkTo = function (url, params = {}) {
      params._from = util.parseHashQuery({
        _from: ''
      })
      let array = []
      for (let key in params) {
        array.push(`${key}=${encodeURIComponent(params[key])}`)
      }
      location.replace(url + '?' + array.join('&'))
    }
    Vue.prototype._inputFocus = function (name) {
      this.$nextTick(() => {
        var input = this.$refs[name]
        if (input instanceof Array) {
          input = input[0]
        }
        input.focus()
        input.$el.querySelector('input').select()
      })
    }
    Vue.prototype._linkBack = function () {
      let json = util.queryJson()
      if (json._from) {
        let hrefWithoutFrom = util.parseHashQuery({
          _from: ''
        })
        let url = util.parseHashQuery({
          _from: hrefWithoutFrom
        }, json._from)
        location.replace(url)
      } else {
        console.warn('_from not found!', json)
      }
    }
    Vue.prototype._emit = function (evtName, msg) {
      this.$root.eventHub.$emit(evtName, msg)
    }
    Vue.prototype._on = function (evtName, handler) {
      this.$root.eventHub.$on(evtName, handler)
    }
    Vue.prototype._off = function (evtName, handler) {
      if (handler) {
        this.$root.eventHub.$off(evtName, handler)
      } else if (evtName) {
        this.$root.eventHub.$off(evtName)
      } else {
        this.$root.eventHub.$off()
      }
    }
    Vue.prototype._replaceData = function (form) {
      for (var key in form) {
        this[key] = form[key]
      }
    }
}



// WEBPACK FOOTER //
// ./src/Common/meta/index.js